<template>
    <el-breadcrumb class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
                <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
                <!--<a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>-->
                <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>

<script>
    // import pathToRegexp from 'path-to-regexp'

    export default {
        data () {
            return {
                levelList: null
            }
        },
        watch: {
            $route (route) {
                // 如果转到重定向页面，不更新面包屑
                if (route.path.startsWith('/redirect/')) {
                    return;
                }
                this.getBreadcrumb();
            }
        },
        created () {
            this.getBreadcrumb()
        },
        methods: {
            getBreadcrumb () {
                let menus = this.$permission.GetLeftMenus(),
                    matched = this.$route.matched.filter(item => item.name);
                const first = matched[0];
                if (first && first.name !== 'home') {
                    matched = [{path: "/home", name: "home", meta: {title: '首页'}}].concat(matched);
                }
                if(matched && matched.length > 0) {
                    for (let i = 0; i < matched.length; i++) {
                        let tmpMenu = this.$permission.GetMenuByName(matched[i].name);
                        if (tmpMenu && tmpMenu != null && tmpMenu.length > 0) {
                            matched[i].path = tmpMenu[0].url;
                            matched[i].meta.title = tmpMenu[0].display_name;
                        }
                    }
                }

                this.levelList = matched.filter(item => item.meta && item.meta.title);
            }
        }
    }
</script>

<style scoped>
    .app-breadcrumb.el-breadcrumb {
        font-size: 14px;
    }
    .app-breadcrumb.el-breadcrumb .no-redirect {
        color: rgb(1, 5, 138);
        cursor: text;
    }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue